function GeolocationCtrl($scope) {

}